import Footer from "../../base/Footer/Footer";
import { PageContainer, TopicContainer, ContentContainer, HeroBannerContainer } from "./styles";
import { ReactNode } from "react";

interface SinglePageProps {
    heroBanner: ReactNode;
    topic?: ReactNode;
    content: ReactNode;
    children?: ReactNode;
    title: string;
}

const SinglePage: React.FC<SinglePageProps> = ({heroBanner, topic: header, content, title }) => {
    document.title = title + " | Eckenmoorhexen";
    return ( 
        <PageContainer>
            <HeroBannerContainer>{heroBanner}</HeroBannerContainer>
            {header ? <TopicContainer>{header}</TopicContainer> : null}
            <ContentContainer>
                {content}
            </ContentContainer>
            <Footer/>
        </PageContainer>
     );
}

export default SinglePage;
